module.exports = __webpack_public_path__ + "img/130.247f6aa8.jpg";